let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("megar")).then(() => parcelRequire('1W4cJ'));